import $ from 'jquery';
if ($('body').hasClass('search')) {
  openSearch();
}

$('#openSearch').on('click', () => {
  toggleSearchClasses();
});

$('#backSearch').on('click', () => {
  if ($('body').hasClass('search')) {
    history.go(-1);
  } else {
    toggleSearchClasses();
  }
});

function toggleSearchClasses() {
  if ($('#search-box').hasClass('navbar__search-box--show')) {
    closeSearch();
  } else {
    openSearch();
  }
}

function openSearch() {
  $('.navbar').addClass('navbar--search-open');
  $('#search-box').addClass('navbar__search-box--show');
}

function closeSearch() {
  $('.navbar').removeClass('navbar--search-open');
  $('#search-box').removeClass('navbar__search-box--show');
}